import Vue from 'vue';
import App from './App.vue';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ja';
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false;
Vue.use(ElementUI, {locale})

// Array.prototype.includes() polyfill
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value(searchElement: string, fromIndex?: number) {
      console.log('Array.prototype.includes() が 存在しないため、Polyfill を使用します。')
      if (this == null) throw new TypeError('"this" is null or not defined')
      const o = Object(this)
      // tslint:disable-next-line
      const len = o.length >>> 0
      if (len === 0)  return false
      const n = (fromIndex === undefined) ? 0 : fromIndex
      let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)
      const sameValueZero = (x: any, y: any) => {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
      }
      while (k < len) {
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }
      return false;
    },
  })
}
// Array.from() polyfill
if (!Array.from) {
  Array.from = (() => {
    console.log('Array.from() が 存在しないため、Polyfill を使用します。')
    const toStr = Object.prototype.toString;
    const isCallable = (fn: any) => typeof fn === 'function' || toStr.call(fn) === '[object Function]'
    const toInteger = (value: any) => {
      const num = Number(value)
      if (isNaN(num)) { return 0 }
      if (num === 0 || !isFinite(num)) { return num }
      return (num > 0 ? 1 : -1) * Math.floor(Math.abs(num))
    }
    const maxSafeInteger = Math.pow(2, 53) - 1
    const toLength = (value: any) => {
      const len = toInteger(value)
      return Math.min(Math.max(len, 0), maxSafeInteger)
    }

    return function from(this: any, arrayLike: any) {
      const C = this
      const items = Object(arrayLike);
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined')
      }
      // tslint:disable-next-line
      const mapFn = arguments.length > 1 ? arguments[1] : void undefined
      let T: any
      if (typeof mapFn !== 'undefined') {
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }
        if (arguments.length > 2) {
          T = arguments[2]
        }
      }

      const len = toLength(items.length)
      const A = isCallable(C) ? Object(new C(len)) : new Array(len)
      let k = 0
      let kValue: any
      while (k < len) {
        kValue = items[k]
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k)
        } else {
          A[k] = kValue
        }
        k += 1
      }
      A.length = len
      return A
    };
  })();
}

new Vue({
  render: (h) => h(App),
}).$mount('#distributors-searcher');
